import { Component, Input, OnInit } from '@angular/core';
import { NgIf, NgClass } from '@angular/common';

@Component({
  selector: 'bey-avatar',
  templateUrl: './bey-avatar.component.html',
  styleUrls: ['./bey-avatar.component.scss'],
  standalone: true,
  imports: [NgIf, NgClass],
})
export class BeyAvatarComponent implements OnInit {
  /***
   * Size means width and height in Tailwind height and width definition
   * e.g.
   * w-30 h-30
   * h-[24px] w-[24px]
   * etc.
   */
  @Input()
  size: string;

  @Input()
  isSkeleton: boolean = false;

  /**
   * Indicates which variant the avatar should be
   */
  @Input()
  variant: 'outline-dashed' | 'filled' = 'filled';

  constructor() {}

  ngOnInit(): void {}
}
